import { render, staticRenderFns } from "./Slugs.vue?vue&type=template&id=455f50ee&scoped=true&"
import script from "./Slugs.vue?vue&type=script&lang=js&"
export * from "./Slugs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455f50ee",
  null
  
)

export default component.exports